module.exports = __webpack_public_path__ + "img/logo.7a64bd24.png";